export default function FlightsCarouselBaseController(
    $scope,
    $rootScope,
    $q,
    flightsFactory,
    flightsService,
    baseEvents,
    flightFareService,
    l10nService,
) {
    'ngInject';
            const FILTER_BY_AIRLINE_TITLE = l10nService.localize('Show this flight and all flights for');
            $scope.flightFareService = flightFareService;
            $scope.l10nService = l10nService;
            $scope.getFlightSupplierLogoSmall = flightsService.getFlightSupplierLogoSmall;
            $q.when(flightsFactory.getFlights()).then(function(flights) {
                $scope.matrix = flights;
            });

            $scope.sortComparison = function(comparisonFilter, airline, isDirect) {
                flightsFactory.resetSegmentFilterData();
                $rootScope.$broadcast(baseEvents.CLEAR_SEGMENTS);
                $rootScope.$broadcast(baseEvents.COMPARISON_FILTER, {airline, comparisonFilter, isDirect});
            };

            $scope.filterByAirline = function(airline) {
                const hash = `${airline}${Math.random()}`;
                $scope.sortComparison(hash, airline);
            };
            $scope.getTitle = function(airlineName) {
                return `${FILTER_BY_AIRLINE_TITLE} ${airlineName}`;
            };
}



// WEBPACK FOOTER //
// ./src/app/modules/base/controllers/flights/flightsCarouselBaseCtrl.js